import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "w-64" }
const _hoisted_2 = { class: "text-sm break-words" }


const __default__ = {
  inheritAttrs: false,
};

import AIcon from "@ai-nc/a-components/src/components/media/AIcon.vue";
import useToast from "@/services/useToast";
import { ref } from "vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AToast',
  setup(__props) {

const toast = useToast();
const toastRoot = ref<null | HTMLDivElement>(null);

const toastPositions = computed(() => {
  const positionList: Record<string, { top: string }> = {};
  if (!toastRoot.value) return positionList;

  let currentHeight = 1;
  let index = 0;

  for (const [key, item] of Object.entries(toast.toasts)) {
    if (toastRoot.value.children[index]) {
      positionList[key] = { top: currentHeight + "rem" };
      currentHeight += toastRoot.value.children[index].clientHeight / 16 + 1;
      index++;
    } else {
      positionList[key] = { top: currentHeight + "rem" };
      break;
    }
  }

  return positionList;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    _createElementVNode("div", {
      ref_key: "toastRoot",
      ref: toastRoot
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(toast).toasts), ([key, object]) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass([
          'absolute flex gap-4 bg-white right-4 transition-all duration-300 border p-4 rounded border-l-[0.5rem] items-center pointer-events-auto open:-left-1/2 z-[2000]',
          object.severity === 'error'
            ? 'border-alert-error'
            : object.severity === 'warn'
            ? 'border-alert-warn'
            : 'border-primary',
          object.fading || object.new ? '-right-[25rem]' : '',
        ]),
          style: _normalizeStyle(_unref(toastPositions)[key])
        }, [
          (object.severity === 'error')
            ? (_openBlock(), _createBlock(AIcon, {
                key: 0,
                icon: "x-circle",
                class: "text-alert-error w-8 h-8",
                solid: true
              }))
            : _createCommentVNode("", true),
          (object.severity === 'warn')
            ? (_openBlock(), _createBlock(AIcon, {
                key: 1,
                icon: "exclamation-circle",
                class: "text-alert-warn w-8 h-8",
                solid: true
              }))
            : _createCommentVNode("", true),
          (object.severity === 'info')
            ? (_openBlock(), _createBlock(AIcon, {
                key: 2,
                icon: "information-circle",
                class: "text-primary w-8 h-8",
                solid: true
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass([
              'font-bold',
              object.severity === 'error'
                ? 'text-alert-error'
                : object.severity === 'warn'
                ? 'text-alert-warn'
                : 'text-primary',
            ])
            }, _toDisplayString(object.title), 3),
            _createElementVNode("div", _hoisted_2, _toDisplayString(object.message) + " " + _toDisplayString(_unref(toastPositions).value), 1)
          ]),
          _createVNode(AIcon, {
            icon: "x",
            class: "text-gray-400 w-6 h-6 cursor-pointer",
            solid: true,
            onClick: ($event: any) => (_unref(toast).delete(key))
          }, null, 8, ["onClick"])
        ], 6))
      }), 128))
    ], 512)
  ]))
}
}

})